import { Feature, services } from 'data/landing/alternate-landing-data';
import Lottie from 'lottie-react';
import { useAppContext } from 'providers/AppProvider';
import { Col, Row } from 'react-bootstrap';
import earthLight from 'assets/img/animated-icons/rotating-earth.json';
import earthDark from 'assets/img/animated-icons/rotating-earth-dark.json';
import earthPlane from 'assets/img/spot-illustrations/earth-plane.png';
import earthPlaneDark from 'assets/img/spot-illustrations/earth-plane-dark.png';
import Untitledgif from 'assets/img/spot-illustrations/Untitled design.gif';

const primaryTint = 'rgb(11, 61, 0)';

const buildMaskStyle = (image: string) => ({
  width: '100px',
  height: '100px',
  backgroundColor: primaryTint,
  WebkitMaskImage: `url(${image})`,
  maskImage: `url(${image})`,
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskSize: 'contain',
  maskSize: 'contain',
  WebkitMaskPosition: 'center',
  maskPosition: 'center'
});

const tintedServiceIds = [1, 2, 3, 4];

const ServiceItem = ({ service }: { service: Feature }) => {
  const isTinted = tintedServiceIds.includes(service.id);

  return (
    <div className="text-center text-lg-start">
      {isTinted ? (
        <>
          <div
            className="mb-4 mx-auto mx-lg-0 d-dark-none"
            style={buildMaskStyle(service.lightImg)}
          />
          <div
            className="mb-4 mx-auto mx-lg-0 d-light-none"
            style={buildMaskStyle(service.darkImg)}
          />
        </>
      ) : (
        <>
          <img
            src={service.lightImg}
            alt=""
            className="mb-4 d-dark-none"
            width="100"
          />
          <img src={service.darkImg} alt="" className="mb-4 d-light-none" />
        </>
      )}
      <h4 className="mb-2">{service.title}</h4>
      <p>{service.description}</p>
    </div>
  );
};

const OneStopSolution = () => {
  const {
    config: { theme }
  } = useAppContext();
  const { getThemeColor } = useAppContext();
  return (
    <section className="overflow-hidden rotating-earth-container pb-5 pb-md-0 pt-10">
      <div className="container-small px-lg-7 px-xxl-3">
        <Row>
          <Col lg={6} className="text-center text-lg-start">
            {/* <h2 className="mb-2 lh-base">Used by millions of users</h2>
            <h1
              className="fs-4 fs-sm-2 mb-3 fw-black"
              style={{ color: getThemeColor('primary') }}
            >
              WORLDWIDE
            </h1>
            <p className="mb-10">
              Keep it simple with Phoenix and help your organization grow with
              the abundance you look for.
            </p> */}
            <Row className="gy-6">
              {services.map(service => (
                <Col key={service.id} sm={6}>
                  <ServiceItem service={service} />
                </Col>
              ))}
            </Row>
          </Col>
          <Col lg={6}>
            <div className="position-relative position-lg-absolute">
              {/* <Lottie
                animationData={theme === 'light' ? earthLight : earthDark}
                className="lottie"
              /> */}
              <img
                src={Untitledgif}
                alt="rotating earth"
                className="lottie"
                style={{ width: '80%' }}
              />
              {/* <img
                src={earthPlane}
                alt=""
                className="position-absolute d-dark-none"
              />
              <img
                src={earthPlaneDark}
                alt=""
                className="position-absolute d-light-none"
              /> */}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default OneStopSolution;
